export default __webpack_public_path__ + "static/media/wagges.bebb7861.png";